// Elbow joining two bracket matches to the one they feed.
//
// This is geometry, not decoration. A round-N match is centred between its two
// round-(N-1) feeders, which puts those feeders' centres at exactly the quarter
// and three-quarter marks of the round-N cell — so the elbow spans 25%..75% of
// its own cell and its ends land on the two matches it came from.
//
// That only holds while every cell in a round takes an EQUAL share of the
// column height (flex: 1 on each, no fixed heights). Lay the rounds out any
// other way and these lines will point confidently at the wrong matches, which
// is worse than drawing none at all.

import React from 'react';
import Box from '@mui/material/Box';

/** Gap between rounds, in px. The elbow is drawn inside it. */
export const BRACKET_GAP = 20;

const LINE = '2px solid #cbd5e1';

export default function BracketConnector() {
  return (
    <Box
      aria-hidden
      sx={{
        position: 'absolute',
        // Sits in the gap immediately left of the cell it belongs to.
        right: '100%', width: `${BRACKET_GAP}px`,
        top: '25%', height: '50%',
        borderTop: LINE, borderBottom: LINE, borderRight: LINE,
        borderTopRightRadius: 6, borderBottomRightRadius: 6,
        pointerEvents: 'none',
      }}
    />
  );
}
